// Resuelve si un codigo de seccion corresponde a un nodo de navegacion (nivel 1 o 2)
export const resolveNodeRedirect = (nodes, sectionCode) => {
  if (sectionCode == null) return undefined;

  const level1 = nodes?.find(navNode => navNode?.code === sectionCode);
  if (level1) return level1;

  let found;
  nodes?.find(navNode => {
    const level2 = navNode?.childs?.find(child => child?.code === sectionCode);
    if (level2) {
      found = level2;
      return true;
    }
    return false;
  });

  return found;
};
